module.exports = __webpack_public_path__ + "img/3PVRActivationIT.795b734b.png";